import { darkenToContrast, readableTextOn } from './colorAttributes'

export const DEFAULT_LINK_BUTTON_COLOR = '#045db5'

export const LINK_BUTTON_VARIANTS = ['solid', 'outline']
export const DEFAULT_LINK_BUTTON_VARIANT = 'solid'

// Inline styles of the "Link button" block, shared by renderHTML (saved HTML) and the
// editor node view so both look the same. The public page has no `prose` nor CSS
// variables, hence everything inline.
export const LINK_BUTTON_STYLES = {
  wrapper: 'margin:16px 0;',
}

// Unknown or missing variants fall back to the default.
export function normalizeLinkButtonVariant(value) {
  return LINK_BUTTON_VARIANTS.includes(value) ? value : DEFAULT_LINK_BUTTON_VARIANT
}

// `color` must already be a validated #rrggbb. Both variants have a 2px border so they are
// the same height (12 + 20 + 12 + 2 + 2 = 48px, above the 44px touch target).
// break-word: a word only breaks when it alone doesn't fit (the aside can be ~200px wide).
export function linkButtonStyle(color, variant) {
  const colors = normalizeLinkButtonVariant(variant) === 'outline'
    ? `background-color:transparent;color:${darkenToContrast(color, '#ffffff')};`
    : `background-color:${color};color:${readableTextOn(color)};`

  return 'display:block;width:100%;box-sizing:border-box;text-align:center;overflow-wrap:break-word;'
    + `border:2px solid ${color};${colors}`
    + 'padding:12px 20px;font-size:16px;line-height:20px;font-weight:bold;'
    + 'border-radius:10px;text-decoration:none;'
}
